import styles from './dashboard.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';
import RetinaImage from 'src/components/RetinaImage';
import TeamDetailsSection from 'src/components/TeamDetailsSection';
import FeaturesLinksSection from 'src/components/FeaturesLinksSection';
import MobileGeographySection from 'src/components/MobileGeographySection';
import TestimonialsSection from 'src/components/TestimonialsSection';

import ImgHands from 'src/images/img-hands.jpg';
import ImgHands2x from 'src/images/img-hands@2x.jpg';
import ImgHands3x from 'src/images/img-hands@3x.jpg';
import IconTeams from 'src/images/icon-teams.png';
import IconTeams2x from 'src/images/icon-teams@2x.png';
import IconTeams3x from 'src/images/icon-teams@3x.png';

const Hero = (props) => (
  <div styleName='hero'>
      <Container>
          <div styleName='text-container'>
              <RetinaImage srcSet={[IconTeams, IconTeams2x, IconTeams3x]} />
              <div className='h1 mt-2'>Teams</div>
              <div className='h2 text-blue'>Many hands make light work.</div>
              <div styleName='message'>
                  What do a customer service rep, a cost accountant and the COO
                  all have in common? They all need to know what’s going on with
                  your shipping. And now they can, with team management.
                  Effortlessly assign and revoke accounts across your org, and let
                  individual users access the data they need.
              </div>
              <ButtonLink styleName='button' to='/contact'>
                  Try free for 7 days
              </ButtonLink>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container' style={{width: '650px'}}>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgHands, ImgHands2x, ImgHands3x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);

export default (props) => (
  <div>
      <Hero />
      <TeamDetailsSection />
      <MobileGeographySection />
      <TestimonialsSection />
      <FeaturesLinksSection />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/features/teams.js